import { useTranslation } from '@axo/shared/i18n';
import CheckboxUI, {
  ICheckbox,
} from '@axo/shared/ui/input/lib/Checkbox/CheckboxUI';
import { Controller, useFormContext } from 'react-hook-form';
import { useReloadValue } from '../../hooks';
import { IField } from '../UI.types';

type Props<Fields> = IField<Fields> & ICheckbox;

export function CheckboxFieldUI<Fields>({
  name,
  registerOptions,
  'data-testid': testid,
  error: formControllerError,
  ...props
}: Props<Fields>) {
  const { t } = useTranslation();

  const {
    formState: { errors },
  } = useFormContext();

  useReloadValue(name);

  const error = errors[name]?.message || formControllerError;

  const message = typeof error === 'string' ? t(error) : undefined;

  return (
    <Controller
      name={name}
      rules={registerOptions}
      render={({ field }) => (
        <CheckboxUI error={message} testid={testid} {...props} {...field} />
      )}
    />
  );
}
